import { render, staticRenderFns } from "./RealEstateOrderView.vue?vue&type=template&id=bc5a4040&scoped=true"
import script from "./RealEstateOrderView.vue?vue&type=script&lang=ts"
export * from "./RealEstateOrderView.vue?vue&type=script&lang=ts"
import style0 from "./RealEstateOrderView.vue?vue&type=style&index=0&id=bc5a4040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5a4040",
  null
  
)

export default component.exports